<div class="customizerNav">
  <ng-scrollbar class="relative" style="height: calc(100vh - 85px)">
    <div class="p-6">
      <h6 class="text-base font-semibold mb-4! rtl:text-right">
        {{ 'layout.customizer.themeOption' | translate }}
      </h6>
      <mat-button-toggle-group
        [ngModel]="options().theme"
        (ngModelChange)="setTheme($event)"
        class="customizer-button-group gap-4"
        [hideSingleSelectionIndicator]="hideSingleSelectionIndicator()"
      >
        <mat-button-toggle value="light">
          <div class="flex items-center font-medium">
            <i-tabler name="sun-high" class="flex me-2 fill-icon"></i-tabler>
            {{ 'layout.customizer.themeLight' | translate }}
          </div>
        </mat-button-toggle>
        <mat-button-toggle value="dark">
          <div class="flex items-center font-medium">
            <i-tabler name="moon" class="flex me-2 fill-icon"></i-tabler>
            {{ 'layout.customizer.themeDark' | translate }}
          </div>
        </mat-button-toggle>
      </mat-button-toggle-group>

      <h6 class="text-base font-semibold mb-4! mt-6! rtl:text-right">
        {{ 'layout.customizer.themeDirection' | translate }}
      </h6>

      <mat-button-toggle-group
        [ngModel]="options().dir"
        (ngModelChange)="setDir($event)"
        class="customizer-button-group gap-4"
        [hideSingleSelectionIndicator]="hideSingleSelectionIndicator()"
      >
        <mat-button-toggle value="ltr">
          <div class="flex items-center font-medium">
            <i-tabler name="text-direction-ltr" class="flex me-2 fill-icon"></i-tabler>
            {{ 'layout.customizer.dirLtr' | translate }}
          </div>
        </mat-button-toggle>
        <mat-button-toggle value="rtl">
          <div class="flex items-center font-medium">
            <i-tabler name="text-direction-rtl" class="flex me-2 fill-icon"></i-tabler>
            {{ 'layout.customizer.dirRtl' | translate }}
          </div>
        </mat-button-toggle>
      </mat-button-toggle-group>

      @if (!options().horizontal) {
        <div>
          <h6 class="text-base font-semibold mb-4! mt-6! pt-4 rtl:text-right">
            {{ 'layout.customizer.sidebarType' | translate }}
          </h6>

          <mat-button-toggle-group
            [ngModel]="asYesNo(options().sidenavCollapsed)"
            (ngModelChange)="setSidebarCollapsed($event)"
            class="customizer-button-group gap-4"
            [hideSingleSelectionIndicator]="hideSingleSelectionIndicator()"
          >
            <mat-button-toggle value="no">
              <div class="flex items-center font-medium">
                <i-tabler name="layout-sidebar-right" class="flex me-2 fill-icon"></i-tabler>
                {{ 'layout.customizer.sidebarFull' | translate }}
              </div>
            </mat-button-toggle>
            <mat-button-toggle value="yes">
              <div class="flex items-center font-medium">
                <i-tabler name="layout-sidebar" class="flex me-2 fill-icon"></i-tabler>
                {{ 'layout.customizer.sidebarMini' | translate }}
              </div>
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      }

      <h6 class="text-base font-semibold mb-4! mt-6! pt-4 rtl:text-right">
        {{ 'layout.customizer.layoutType' | translate }}
      </h6>

      <mat-button-toggle-group
        [ngModel]="asYesNo(options().horizontal)"
        (ngModelChange)="setHorizontal($event)"
        class="customizer-button-group gap-4"
        [hideSingleSelectionIndicator]="hideSingleSelectionIndicator()"
      >
        <mat-button-toggle value="no">
          <div class="flex items-center font-medium">
            <i-tabler name="layout-distribute-vertical" class="flex me-2 fill-icon"></i-tabler>
            {{ 'layout.customizer.layoutVertical' | translate }}
          </div>
        </mat-button-toggle>
        <mat-button-toggle value="yes">
          <div class="flex items-center font-medium">
            <i-tabler name="layout-distribute-horizontal" class="flex me-2 fill-icon"></i-tabler>
            {{ 'layout.customizer.layoutHorizontal' | translate }}
          </div>
        </mat-button-toggle>
      </mat-button-toggle-group>

      <h6 class="text-base font-semibold mb-4! mt-6! pt-4 rtl:text-right">
        {{ 'layout.customizer.cardWith' | translate }}
      </h6>

      <mat-button-toggle-group
        [ngModel]="asYesNo(options().cardBorder)"
        (ngModelChange)="setCardBorder($event)"
        class="customizer-button-group gap-4"
        [hideSingleSelectionIndicator]="hideSingleSelectionIndicator()"
      >
        <mat-button-toggle value="no">
          <div class="flex items-center font-medium">
            <i-tabler name="shadow" class="flex me-2 fill-icon"></i-tabler>
            {{ 'layout.customizer.cardShadow' | translate }}
          </div>
        </mat-button-toggle>
        <mat-button-toggle value="yes">
          <div class="flex items-center font-medium">
            <i-tabler name="shadow-off" class="flex me-2 fill-icon"></i-tabler>
            {{ 'layout.customizer.cardBorder' | translate }}
          </div>
        </mat-button-toggle>
      </mat-button-toggle-group>

      <h6 class="text-base font-semibold mb-4! mt-6! pt-4 rtl:text-right">
        {{ 'layout.customizer.containerOption' | translate }}
      </h6>

      <mat-button-toggle-group
        [ngModel]="asYesNo(options().boxed)"
        (ngModelChange)="setBoxed($event)"
        class="customizer-button-group gap-4"
        [hideSingleSelectionIndicator]="hideSingleSelectionIndicator()"
      >
        <mat-button-toggle value="no">
          <div class="flex items-center font-medium">
            <i-tabler name="layout-navbar" class="flex me-2 fill-icon"></i-tabler>
            {{ 'layout.customizer.containerFull' | translate }}
          </div>
        </mat-button-toggle>
        <mat-button-toggle value="yes">
          <div class="flex items-center font-medium">
            <i-tabler name="layout-sidebar" class="flex me-2 fill-icon"></i-tabler>
            {{ 'layout.customizer.containerBoxed' | translate }}
          </div>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </ng-scrollbar>
</div>
